import React from "react";

// Admin Navigation Icons
export const DashboardIcon = (props) => (
  <svg
    className="w-7 h-7"
    width="28"
    height="28"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
    />
  </svg>
);
export const LedgerIcon = (props) => (
  <svg
    className="w-7 h-7"
    width="28"
    height="28"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
    />
  </svg>
);
export const BookingRequestIcon = (props) => (
  <svg
    className="w-7 h-7"
    width="28"
    height="28"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect
      x="4"
      y="7"
      width="16"
      height="10"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <line
      x1="8"
      y1="7"
      x2="8"
      y2="17"
      stroke="currentColor"
      strokeWidth="2"
      strokeDasharray="2,2"
    />
    <path
      d="M14 13l2 2 4-4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TicketsIcon = (props) => (
  <svg
    className="w-7 h-7"
    width="28"
    height="28"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
    />
  </svg>
);
export const CustomersIcon = (props) => (
  <svg
    className="w-7 h-7"
    width="28"
    height="28"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    />
  </svg>
);
export const LocationsIcon = (props) => (
  <svg
    className="w-7 h-7"
    width="28"
    height="28"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 21c-4.418 0-8-5.03-8-9.25C4 6.477 7.134 3 12 3s8 3.477 8 8.75C20 15.97 16.418 21 12 21z"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <circle
      cx="12"
      cy="10"
      r="3"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
  </svg>
);
export const AirlinesIcon = (props) => (
  <svg
    className="w-7 h-7"
    width="28"
    height="28"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.5 19l8.5-7L2.5 5v2.5l7 4-7 4V19zm19 0l-8.5-7L21.5 5v2.5l-7 4 7 4V19z"
    />
  </svg>
);
export const AuditIcon = (props) => (
  <svg
    className="w-7 h-7"
    width="28"
    height="28"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 11l3 3L22 4" />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 8h10M7 16h6" />
    <rect
      x="7"
      y="2"
      width="10"
      height="4"
      rx="1"
      ry="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AdminsIcon = (props) => (
  <svg
    className="w-7 h-7"
    width="28"
    height="28"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 3l8 4v5c0 5.25-3.75 9.75-8 10.5C7.75 21.75 4 17.25 4 12V7l8-4z"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
  </svg>
);

// Payment Modal Icons
export const PaidIcon = (props) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="12" fill="#22C55E" />
    <path
      d="M7 12l3 3 5-5"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UnpaidIcon = (props) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="12" fill="#EF4444" />
    <path
      d="M7 7l10 10M17 7l-10 10"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const OnlineIcon = (props) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <rect x="3" y="6" width="18" height="12" rx="3" fill="#6366F1" />
    <rect x="7" y="14" width="10" height="2" rx="1" fill="#fff" />
    <circle cx="9" cy="10" r="1" fill="#fff" />
  </svg>
);
export const CashIcon = (props) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <rect x="3" y="7" width="18" height="10" rx="3" fill="#F59E42" />
    <circle cx="12" cy="12" r="3" fill="#fff" />
  </svg>
);

// Spinner Icons
export const SpinnerIcon = (props) => (
  <svg
    className={`animate-spin -ml-1 mr-1 ${
      props.size || "h-3 w-3"
    } text-current`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);
export const AirplaneSpinnerIcon = (props) => (
  <svg
    width="120"
    height="60"
    viewBox="0 0 120 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="mb-4"
    {...props}
  >
    <ellipse cx="30" cy="40" rx="18" ry="8" fill="#e0e7ef">
      <animate
        attributeName="cx"
        values="30;90;30"
        dur="2.5s"
        repeatCount="indefinite"
      />
    </ellipse>
    <ellipse cx="60" cy="50" rx="12" ry="5" fill="#f1f5fa">
      <animate
        attributeName="cx"
        values="60;10;60"
        dur="3s"
        repeatCount="indefinite"
      />
    </ellipse>
    <g>
      <rect
        x="0"
        y="25"
        width="28"
        height="8"
        rx="3"
        fill="#3b82f6"
        transform="rotate(10 0 25)"
      >
        <animateTransform
          attributeName="transform"
          type="translate"
          from="0 0"
          to="90 0"
          dur="2s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x="2"
        y="22"
        width="4"
        height="6"
        rx="1"
        fill="#2563eb"
        transform="rotate(10 2 22)"
      >
        <animateTransform
          attributeName="transform"
          type="translate"
          from="0 0"
          to="90 0"
          dur="2s"
          repeatCount="indefinite"
        />
      </rect>
      <circle cx="28" cy="29" r="3" fill="#60a5fa">
        <animateTransform
          attributeName="transform"
          type="translate"
          from="0 0"
          to="90 0"
          dur="2s"
          repeatCount="indefinite"
        />
      </circle>
    </g>
  </svg>
);

// TableHeader and Dialog Icons
export const ClearSearch = (props) => (
  <svg
    className="w-5 h-5"
    fill="currentColor"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);
export const CloseIcon = (props) => (
  <svg
    className="h-4 w-4"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

// OtherOfferingsCard and TicketCard Arrow
export const ArrowRightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    className="w-6 h-6"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 8l4 4m0 0l-4 4m4-4H3"
    />
  </svg>
);

// Select Dropdown and Checkmark
export const DropdownArrowIcon = ({ isOpen, ...props }) => (
  <svg
    className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""}`}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
);
export const CheckmarkIcon = (props) => (
  <svg
    className="h-4 w-4 opacity-0"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 13l4 4L19 7"
    />
  </svg>
);

// Sidebar and User Icons
export const SidebarOpenIcon = (props) => (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.25 4.5l7.5 7.5-7.5 7.5"
    />
  </svg>
);
export const SidebarCloseIcon = (props) => (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 19.5L8.25 12l7.5-7.5"
    />
  </svg>
);
export const UserIcon = (props) => (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
    />
  </svg>
);

// BookingCard Icons
export const AirlineLogoIcon = (props) => (
  <svg
    className="w-6 h-6 text-indigo-500"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2.5 19l19-7-19-7v6l15 1-15 1v6z" />
  </svg>
);
export const StatusCircleIcon = (props) => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <circle cx="10" cy="10" r="10" />
  </svg>
);
export const WarningIcon = (props) => (
  <svg
    className="w-12 h-12 text-yellow-400 mb-4"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 8v4l3 3" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="10" />
  </svg>
);
